// geo.js — keyless, client-side geocoding + weather helpers.
// Reverse geocoding: BigDataCloud reverse-geocode-client (browser-only, no key).
// Forward geocoding + weather: Open-Meteo (no key, CORS enabled).

export async function reverseGeocode(lat, lon, lang = "en") {
  const r = await fetch(
    `https://api.bigdatacloud.net/data/reverse-geocode-client?latitude=${lat}&longitude=${lon}&localityLanguage=${lang}`
  );
  const d = await r.json();
  const parts = [d.city || d.locality, d.principalSubdivision, d.countryName].filter(Boolean);
  return parts.slice(0, 2).join(", ") || `${lat.toFixed(3)}, ${lon.toFixed(3)}`;
}

export async function forwardGeocode(name, lang = "en") {
  const r = await fetch(
    `https://geocoding-api.open-meteo.com/v1/search?name=${encodeURIComponent(name)}&count=1&language=${lang}`
  );
  const d = await r.json();
  if (!d.results || !d.results.length) return null;
  const g = d.results[0];
  return {
    lat: g.latitude,
    lon: g.longitude,
    name: [g.name, g.admin1, g.country].filter(Boolean).slice(0, 2).join(", "),
    elevation: g.elevation,
  };
}

export async function fetchWeather(lat, lon) {
  const r = await fetch(
    `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current=temperature_2m,surface_pressure`
  );
  const d = await r.json();
  return {
    tempC: d.current?.temperature_2m ?? null,
    pressureHpa: d.current?.surface_pressure ?? null,
  };
}
